import back from "../../../../../assets/icons/ic_caret_left.svg";
import { useDictionary } from "../../../../../utilities/hooks/UseDictionary";
import SimpleLoader from "../../../common/SimpleLoader";
import * as common from "../../../common/__redux/commonRedux";
import DropdownButton from "../../../common/dropdown_button/DropdownButton";
import StatusLabel from "../../../common/status-label/StatusLabel";
import { getBookingDetails } from "../networking";
import { deleteOfflineBooking } from "../../provider_calendar/networking";
import NewBookingDialog from "../../provider_calendar/NewBookingDialog";
import ConfirmationModal from "../../../common/ConfirmationModal";
import BookingExperienceDetails from "./BookingExperienceDetails";
import CancelBookingDialog from "./CancelBookingDialog";
import SendInvoiceDialog from "./SendInvoiceDialog";
import Invoice from "./tabs/invoice/Invoice";
import ParticipantsAndAddons from "./tabs/pariticipants_and_addons/ParticipantsAndAddons";
import Payments from "./tabs/payments/Payments";
import Reviews from "./tabs/reviews/BookingReview";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { NavigatorPaths } from "../../../../../assets/dictionaries/NavigatorPaths";
import { ReactComponent as CheckIcon } from "../../../../../assets/icons/ic_check.svg";
import { ReactComponent as CalendarIcon } from "../../../../../assets/icons/ic_calendar.svg";
import { ReactComponent as CloseIcon } from "../../../../../assets/icons/ic_close.svg";
import { ReactComponent as DateCalendarIcon } from "../../../../../assets/icons/ic_calendar_date.svg";
import { ReactComponent as EnvelopeIcon } from "../../../../../assets/icons/ic_envelope.svg";
import { ReactComponent as CancelIcon } from "../../../../../assets/icons/ic_close_round.svg";
import { ReactComponent as CellPhoneIcon } from "../../../../../assets/icons/ic_phone.svg";
import { ReactComponent as DeleteIcon } from "../../../../../assets/icons/ic_trash.svg";
import { ReactComponent as ShareIcon } from "../../../../../assets/icons/ic_share.svg";
import SuggestDateDialog from "../../provider_home/booking_requests/SuggestDateDialog";
import RejectRequestDialog from "../../provider_home/booking_requests/RejectRequestDialog";
import BookingNotes from "./tabs/booking_notes/BookingNotes";
import { updateBookingRequestState } from "../../provider_home/networking";
import ConfirmRequestDialog from "../../provider_home/booking_requests/ConfirmRequestDialog";
import ExperienceDetailDialog from "../../resale_hub/components/ExperienceDetailDialog";
import CustomToast from '../../../common/CustomToast';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BookingDetails = ({ setErrorMessage }) => {
	const { id } = useParams();
	const dictionary = useDictionary();
	const history = useHistory();

	const [tabIndex, setTabIndex] = useState(0);
	const [opacity, setOpacity] = useState(0);
	const [showLoader, setLoaderVisibility] = useState(true);
	const [showSendInvoiceDialog, , setShowSendInvoiceDialog] = useState(false);
	const [bookingStatus, setBookingStatus] = useState(null);
	const [paymentStatus, setPaymentStatus] = useState(null);
	const [moreStatus, setMoreStatus] = useState(null);
	const [details, setDetails] = useState(null);
	const [showCancelDialog, setCancelDialogVisibility] = useState(false);
	const [showSuggestDateDialog, setShowSuggestDateDialog] = useState(false);
	const [showConfirmRequestDialog, setShowConfirmRequestDialog] = useState(false);
	const [showRejectRequestDialog, setShowRejectRequestDialog] = useState(false);
	const [selectedViewUrl, setSelectedViewUrl] = useState(null);
	const [showEditDialog, setShowEditDialog] = useState(false);
	const [showDeleteDialog, setShowDeleteDialog] = useState(false);

	const acceptedAsOffline =
		details?.accepted_as_offline === true ||
		details?.accepted_as_offline === 1 ||
		details?.accepted_as_offline === '1';
	const canUseStandardMoreActions =
		bookingStatus === "confirmed" || bookingStatus === "reschedule";

	const isCancellable = useMemo(
		() =>
			(details?.status.key === "pending" || details?.status.key === "confirmed" || details?.status.key === "reschedule") &&
			(details?.payment_status.key === "pending" || details?.payment_status.key === "paid" || details?.payment_status.key === "no_charge") &&
			moment.unix(details?.slot.start_time).valueOf() > new Date().valueOf(),
		[details]
	);

	const isExpired = useMemo(() => moment.unix(details?.slot.start_time).valueOf() < new Date().valueOf(), [details])

	const isReschedulable = useMemo(
		() => details?.status.key === "confirmed" && details.payment_status.key === "paid",
		[details]
	);

	const isPhoneAble = useMemo(() => details?.customer.phone, [details]);

	// const isMessageAble = useMemo(() => ((details?.status.key === "confirmed" || details?.status.key === "reschedule") && details.payment_status.key === "paid"), [details]);
	const isMessageAble = useMemo(() => ((details?.status.key === "confirmed" || details?.status.key === "reschedule") && details.payment_status.key === "paid") || (details?.status.key === "reschedule" && details.payment_status.key === "pending"), [details]);

	useEffect(() => {
		setTimeout(() => {
			setOpacity(1);
		}, 10);

		getDetailsByIdAsync();
	}, []);

	const getDetailsByIdAsync = async () => {
		setLoaderVisibility(true)
		try {
			let { data } = await getBookingDetails(id);
			setDetails(data);
			setBookingStatus(data.status.value);
			setPaymentStatus(data.payment_status.value);

			setLoaderVisibility(false);
		} catch (e) {
			setLoaderVisibility(false);
			if (e.response) {
				setErrorMessage(e.response.data.error_code.toString());
				setTimeout(() => {
					setErrorMessage("");
					dismiss();
				}, 2000);
			}
		}
	};

	const routeMap = {
		0: <ParticipantsAndAddons details={details} />,
		1: <Invoice details={details} />,
		2: <Payments details={details} onRecorded={getDetailsByIdAsync} />,
		3: <BookingNotes details={details} />,
		4: <Reviews details={details} />
	};

	const moreOptions = {
		0: {
			text: dictionary.reschedule,
			icon: <DateCalendarIcon />,
			// disabled: !isCancellable 
			disabled: !isReschedulable || isExpired
		},
		1: {
			text: dictionary.message_customer,
			icon: <EnvelopeIcon />,
			//disabled: !isReschedulable
			disabled: !isMessageAble
		},
		2: {
			text: dictionary.call_customer,
			icon: <CellPhoneIcon />,
			disabled: !isPhoneAble || !canUseStandardMoreActions,
			type: 'call',
			phone: details?.customer.phone
		},
		3: {
			text: dictionary.cancel,
			icon: <CancelIcon />,
			disabled: !isCancellable
		},
		// Share + Delete are offered only for offline bookings — manually
		// created, so no email is sent and the provider shares the link
		// themselves; and the only ones the provider can hard-remove.
		...(acceptedAsOffline
			? {
					4: {
						text: dictionary.share,
						icon: <ShareIcon />,
						disabled: !details?.booking_url
					},
					5: {
						text: dictionary.delete,
						icon: <DeleteIcon />,
						disabled: false
					}
			  }
			: {})
	};

	const dismiss = () => {
		// setOpacity(0);
		history.goBack();
		// history.push("/bookings");
	};

	const handleOpenDetailDialog = (viewUrl) => {
		setSelectedViewUrl(viewUrl);
	};

	const handleCloseDetailDialog = () => {
		setSelectedViewUrl(null);
	};

	useEffect(() => {
		if (moreStatus === dictionary.cancel) {
			setCancelDialogVisibility(true);
		}
		if (moreStatus === dictionary.reschedule) {
			handleOpenSuggestDateDialog();
		}
		if (moreStatus === dictionary.message_customer) {
			window.location.href = "mailto:" + details.customer.email;
		}
		if (moreStatus === dictionary.delete) {
			setShowDeleteDialog(true);
		}
		if (moreStatus === dictionary.share) {
			handleCopyBookingLink();
		}
	}, [moreStatus]);

	// Copies the customer-facing booking link to the clipboard. Used for
	// offline bookings, where the customer never receives an email and the
	// provider passes the link on themselves. `moreStatus` is reset so the
	// same menu entry can be selected again to copy once more.
	const handleCopyBookingLink = () => {
		if (!details?.booking_url) {
			return;
		}
		navigator.clipboard.writeText(details.booking_url).then(
			() => {
				toast.success(<CustomToast message={dictionary.link_copied} />, {
					position: 'bottom-left',
					autoClose: 3000,
					toastId: 'booking-link-copied',
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: false,
					progress: undefined,
					closeButton: false,
					icon: false,
					className: 'toast-white-warning'
				});
				setMoreStatus(null);
			},
			// eslint-disable-next-line no-unused-vars
			(err) => {}
		);
	};

	// Self-managed: closes the confirm modal up-front, shows the page loader
	// while the request runs, then navigates back on success / toasts on error.
	const handleDeleteBooking = () => {
		setShowDeleteDialog(false);
		setLoaderVisibility(true);
		deleteOfflineBooking(id)
			.then(() => {
				dismiss();
			})
			.catch((error) => {
				setLoaderVisibility(false);
				if (error?.response?.data?.message) {
					toast.error(<CustomToast message={error.response.data.message} />, {
						position: 'bottom-left',
						autoClose: 5000,
						toastId: 'max',
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: false,
						progress: undefined,
						closeButton: false,
						icon: false,
						className: 'toast-white-warning'
					});
				}
			});
	};

	const handleOpenSuggestDateDialog = () => {
		setShowSuggestDateDialog(true);
	};

	const handleOpenRejectRequestDialog = () => {
		setShowRejectRequestDialog(true);
	};

	const handleOpenConfirmRequestDialog = () => {
		setShowConfirmRequestDialog(true);
	};

	const handleUpdateRequestStatus = async (data) => {
		try {
			setLoaderVisibility(true);
			await updateBookingRequestState(id, data);
			await getDetailsByIdAsync();
			setLoaderVisibility(false);
		} catch (error) {
			setLoaderVisibility(false);
			if (error?.response?.data?.message) {
				toast.error(<CustomToast message={error.response.data.message} />,
				{
					position: 'bottom-left',
					autoClose: 5000,
					toastId: 'max',
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: false,
					progress: undefined,
					closeButton: false,
					icon: false,
					className: 'toast-white-warning'
				});
			}
		}
	};

	const handleClickSeeCalendar = () => {
		history.push(`/${NavigatorPaths.calendar.path}`, details)
	}

	return (
		<div
			className="calendar-container"
			style={{
				// position: 'relative', commented this for making Experience dialoge work well, if any issue need to discuss
				background: 'var(--background-color)',
				paddingTop: '0'
			}}
		>
			<div className="booking-details-wrapper" style={{ opacity: opacity }}>
				<div className={"booking-header-container booking-header-container-details"}>
					<div className="booking-header-title">
						<div className="booking-detail-back-button" onClick={() => dismiss()}>
							<img src={back} />
						</div>
						<h2 style={{ marginLeft: "8px", fontWeight: 500 }} data-testid="booking-details-header">
							{dictionary.booking + " " + (details?.display_id ?? "")}
						</h2>
					</div>

					<div className="booking-status-labels-container">
						<StatusLabel type="booking" status={bookingStatus}/>
						<StatusLabel type="payment" status={paymentStatus}/>
						{bookingStatus === 'pending' && !isExpired &&
							<>
								<button
									className="button button--small confirm-button"
									onClick={handleOpenConfirmRequestDialog}
								>
									<CheckIcon/> {dictionary.confirm}
								</button>
								<button className="secondary-button reject-button" onClick={handleOpenRejectRequestDialog}>
									<CloseIcon /> {dictionary.decline}
								</button>
								<div className="divider" style={{ marginLeft: 8, marginRight: 8 }}></div>
								<button
									className="button secondary-button button--small reject-button"
									onClick={handleOpenSuggestDateDialog}
								>
									<DateCalendarIcon />
									{dictionary.suggest_new_date}
								</button>
								<button className="button secondary-button button--small reject-button" onClick={handleClickSeeCalendar}>
									<CalendarIcon />
									{dictionary.see_calendar}
								</button>
							</>
						}
						{/*{(bookingStatus === 'pending' || bookingStatus === 'confirmed') &&*/}
						{/*	<>*/}
						{/*		<button*/}
						{/*			className="button secondary-button button--small reject-button"*/}
						{/*			onClick={handleOpenSuggestDateDialog}*/}
						{/*		>*/}
						{/*			<AddUserIcon/>*/}
						{/*			{dictionary.add_participant}*/}
						{/*		</button>*/}
						{/*		<button*/}
						{/*			className="button secondary-button button--small reject-button"*/}
						{/*			onClick={handleOpenSuggestDateDialog}*/}
						{/*		>*/}
						{/*			<AddOnIcon/>*/}
						{/*			{dictionary.add_addon}*/}
						{/*		</button>*/}
						{/*	</>*/}
						{/*}*/}
						{/*{bookingStatus === "confirmed" && (*/}
						{/*	<button className="button secondary-button button--small reject-button">*/}
						{/*		<EnvelopeIcon />*/}
						{/*		{dictionary.send_invoice}*/}
						{/*	</button>*/}
						{/*)}*/}

						{(canUseStandardMoreActions || acceptedAsOffline) && (
							<DropdownButton
								label={dictionary.more}
								options={moreOptions}
								option={moreStatus}
								setOption={setMoreStatus}
							/>
						)}
					</div>
				</div>

				<div className="booking-details-body">
					<div className="booking-details-container" style={{maxHeight: 'calc(100vh - 248px)'}}>
						<div className="settings-tab-bar">
							<div
								onClick={() => setTabIndex(0)}
								className={tabIndex === 0 ? "settings-tab settings-tab-active" : "settings-tab"}
								data-testid="participants-and-addons-tab"
							>
								{dictionary.participants}
							</div>
							{(paymentStatus === "paid" || paymentStatus === "refunded") && (
								<div
									onClick={() => setTabIndex(1)}
									className={
										tabIndex === 1
											? 'settings-tab settings-tab-active'
											: 'settings-tab'
									}
									data-testid="invoice-tab"
								>
									{dictionary.invoice}
								</div>
							)}
							{(acceptedAsOffline || paymentStatus === "paid" || paymentStatus === "refunded" || paymentStatus === "partial_refunded") && (
								<div
									onClick={() => setTabIndex(2)}
									className={
										tabIndex === 2
											? 'settings-tab settings-tab-active'
											: 'settings-tab'
									}
									data-testid="payments-tab"
								>
									{dictionary.payments}
								</div>
							)}
							{!!details?.notes &&
								Object.keys(details.notes).some(
									(key) => key !== 'internal'
								) && (
								<div
									onClick={() => setTabIndex(3)}
									className={tabIndex === 3 ? "settings-tab settings-tab-active" : "settings-tab"}
									data-testid="booking-note-tab"
								>
									{dictionary.booking_notes}
								</div>
							)}
							{!!(details?.reviews && details?.reviews.length) && (
							<div
								onClick={() => setTabIndex(4)}
								className={tabIndex === 4 ? "settings-tab settings-tab-active" : "settings-tab"}
							>
								{dictionary.providerReviews}
							</div>
							)}
						</div>
						{details ? routeMap[tabIndex] : null}
						<SimpleLoader showLoader={showLoader} />
					</div>
					{details ? (
						<BookingExperienceDetails
							details={details}
							viewExperienceHandler={handleOpenDetailDialog}
							onEditBooking={
								acceptedAsOffline
									? () => setShowEditDialog(true)
									: undefined
							}
						/>
					) : null}
				</div>
				{showSendInvoiceDialog && <SendInvoiceDialog />}
				{showCancelDialog && details && (
					<CancelBookingDialog
						details={details}
						dismissDetails={dismiss}
						setShow={setCancelDialogVisibility}
					/>
				)}
				{showConfirmRequestDialog && (
					<ConfirmRequestDialog
						detail={details}
						onConfirm={handleUpdateRequestStatus}
						setShowDialog={setShowConfirmRequestDialog}
					/>
				)}
				{showSuggestDateDialog && (
					<SuggestDateDialog
						isConfirmed={bookingStatus === "confirmed"}
						request={details}
						onSuggest={handleUpdateRequestStatus}
						setShowDialog={setShowSuggestDateDialog}
					/>
				)}
				{showRejectRequestDialog && (
					<RejectRequestDialog
						onReject={handleUpdateRequestStatus}
						setShowDialog={setShowRejectRequestDialog}
					/>
				)}
				{showEditDialog && details && (
					<NewBookingDialog
						mode="edit"
						booking={details}
						setShowDialog={setShowEditDialog}
						onBookingCreated={getDetailsByIdAsync}
					/>
				)}
				{showDeleteDialog && (
					<ConfirmationModal
						setShowModal={setShowDeleteDialog}
						asyncTask={handleDeleteBooking}
						title={dictionary.delete_booking}
						message={dictionary.delete_booking_message}
						action={dictionary.delete_booking}
					/>
				)}
				<ExperienceDetailDialog
				viewUrl={selectedViewUrl}
				showDialog={Boolean(selectedViewUrl)}
				setShowDialog={handleCloseDetailDialog}
			/>
			<ToastContainer />
			</div>
		</div>

	);
};

BookingDetails.propTypes = {
	// bookingId: PropTypes.string.isRequired,
	// dismissDetails: PropTypes.func.isRequired,
	setErrorMessage: PropTypes.func.isRequired
};

export default connect(common.states, common.actions)(BookingDetails);
